export const environment = {
    production: true,
    env: 'production',
    apiUrl: 'https://api.prod.laaps.com.au',
    s3BucketName: '',
    whitelistedDomains: ['api.prod.laaps.com.au'],
    blacklistedRoutes: [],
    recaptcha_site_key: '',
    gaMeasurementId: 'G-3RGL34K95K',
};
